<script lang="ts">
  import type { Response } from '@glimja/storefront/pages/root-page';
  import { RootPage } from '@glimja/storefront/pages';

  const { data }: { data: Response; } = $props();
</script>

<RootPage data={data} />
